"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _logo = _interopRequireDefault(require("../../../assets/images/logo.png"));
var _geogroupAvatar = require("../../geogroup-avatar");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Sponsors({
  defaultParticipationGroup
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: "#fff",
    borderRadius: 4,
    display: "flex",
    gap: 2,
    padding: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexShrink: 0
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    zIndex: 2
  }, /*#__PURE__*/_react.default.createElement(_geogroupAvatar.GeogroupAvatar, {
    geogroup: {
      title: 'Geovelo',
      photo: _logo.default
    },
    size: 48,
    variant: "outlined"
  })), defaultParticipationGroup !== null && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    marginLeft: -2,
    zIndex: 1
  }, /*#__PURE__*/_react.default.createElement(_geogroupAvatar.GeogroupAvatar, {
    geogroup: defaultParticipationGroup,
    size: 48,
    variant: "outlined"
  }))), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, defaultParticipationGroup === undefined ? /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 200
  }) : t('commons.created_by', {
    creator: defaultParticipationGroup ? `Geovelo & ${defaultParticipationGroup.title}` : 'Geovelo'
  })));
}
var _default = exports.default = Sponsors;